import { http } from './client';
import type { MemberInviteInput, MemberInviteResponse, Membership, Role } from './types';

export const membersApi = {
  async list(): Promise<{ items: Membership[] }> {
    const res = await http.get<{ items: Membership[] }>('/v1/org/members');
    return res.data;
  },
  async invite(input: MemberInviteInput): Promise<MemberInviteResponse> {
    const res = await http.post<MemberInviteResponse>('/v1/org/members', input);
    return res.data;
  },
  async setRole(userId: string, role: Role): Promise<{ orgId: string; userId: string; role: Role }> {
    const res = await http.patch<{ orgId: string; userId: string; role: Role }>(
      `/v1/org/members/${encodeURIComponent(userId)}`,
      { role },
    );
    return res.data;
  },
  async remove(userId: string): Promise<{ removed: true; orgId: string; userId: string }> {
    const res = await http.delete<{ removed: true; orgId: string; userId: string }>(
      `/v1/org/members/${encodeURIComponent(userId)}`,
    );
    return res.data;
  },
};
